import React from 'react'

import QuotingPricing from './index.presentational'

const QuotingPricingContainer: React.FC = (): React.ReactElement =>
  React.createElement(QuotingPricing)

export default QuotingPricingContainer
